<script>
  import * as PropTypes from "prop-types";
  import { onMount } from "svelte";
  const { checkPropTypes, object } = PropTypes;
  const propTypes = {
    item: object,
  };
  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "VideoOverlayEmbed");
  });

  export let item;
  const hideSeeMore = false,
    maxWordsInCaption = 6;

  $: isSeeMoreRequired = item.c && item.c.split(" ").length > maxWordsInCaption;

  $: sliceWords =
    item.c && item.c.split(" ").slice(0, maxWordsInCaption).join(" ");

  $: caption = isSeeMoreRequired ? sliceWords : item.c;
</script>

<div class={`bg-transparent shrink-0 p-md`}>
  <a
    href={`/@${item.ath.h}?referrer=embed`}
    target="_blank"
    class="flex items-center text-md font-extrabold text-white"
  >
    <span>@{item.ath.h}</span>
    {#if item.ath.badgeUrl}
      <img
        class="h-md w-md ml-xxs"
        src={item.ath.badgeUrl}
        alt="Badge"
      />
    {/if}
  </a>

  {#if caption}
    <a
      href={`/@${item.ath.h}/video/${item.i}?referrer=embed`}
      target="_blank"
      class="block text-secondary-text-moj"
    >
      {#if isSeeMoreRequired}
        <div>
          <span class="break-words">{caption}</span>
          <span class={`font-bold`}
            >{hideSeeMore ? "...See Less" : "...See More"}</span
          >
        </div>
      {:else}
        <div class="break-words">{caption}</div>
      {/if}
    </a>
  {/if}
</div>
